import createApp from './app'
import './styles/app.scss'

const { app, store, router } = createApp(window.appContext)
app.$mount('#app')
